<template>
  <v-container style="max-width: 1800px !important;">
    <v-row>
      <v-col cols="12">
        <v-dialog
          v-model="dialogAssing"
          fullscreen
          persistent
        >
          <v-card>
            <v-toolbar
              dark
              color="primary"
            >
              <v-btn
                icon
                dark
                @click="closeDialogAssing"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <v-toolbar-title>Asignar Estudios de Imagen - {{assingItem.folio}}</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>

            <v-dialog
              v-model="confirmDialog"
              persistent
              max-width="80%"
            >
              <v-card>
                <v-card-title>
                  Confirmar Asignación de Servicio
                </v-card-title>
                <v-card-text>
                  <div>
                    ¿Estás seguro de que deseas asignar los estudios de imagen al siguiente paciente?
                  </div>
                  <div class="mt-3">
                    <strong>Nombre:</strong> {{ confirmItem.nombre }} {{ confirmItem.apellido_paterno }} {{ confirmItem.apellido_materno }}<br>
                    <strong>Folio:</strong> {{ confirmItem.folio }}
                  </div>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="green" text @click="closeConfigDialog">Cancelar</v-btn>
                  <v-btn color="red" text @click="saveAssing" :loading="savingAssing" :disabled="savingAssing">Confirmar</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <v-card-text>
              <v-row>
                <v-col cols="12">
                  <v-row class="ma-0 pa-0">
                    <v-col   cols="3" class="my-0 py-1">
                      <div class="text-subtitle-2">Apellido Paterno:</div>
                      <div>{{ assingItem.apellido_paterno_paciente }}</div>
                    </v-col>
                    <v-col   cols="3" class="my-0 py-1">
                      <div class="text-subtitle-2">Apellido Materno:</div>
                      <div>{{ assingItem.apellido_materno_paciente }}</div>
                    </v-col>
                    <v-col   cols="3" class="my-0 py-1">
                      <div class="text-subtitle-2">Nombre:</div>
                      <div>{{ assingItem.nombre_paciente }}</div>
                    </v-col>
                    <v-col   cols="3" class="my-0 py-1">
                      <div class="text-subtitle-2">Fecha de Nacimiento:</div>
                      <div>{{ assingItem.fecha_nacimiento }}</div>
                    </v-col>
                    <v-col   cols="3" class="my-0 py-1">
                      <div class="text-subtitle-2">Género:</div>
                      <div>{{ assingItem.genero }}</div>
                    </v-col>
                    <v-col   cols="3" class="my-0 py-1">
                      <div class="text-subtitle-2">Fecha de Realización:</div>
                      <div>{{ assingItem.fecha_realizacion }}</div>
                    </v-col>
                    <v-col   cols="3" class="my-0 py-1">
                      <div class="text-subtitle-2">Marca:</div>
                      <div>{{ assingItem.marca }}</div>
                    </v-col>
                    <v-col   cols="3" class="my-0 py-1">
                      <div class="text-subtitle-2">Modelo:</div>
                      <div>{{ assingItem.modelo }}</div>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="4">
                  <v-carousel
                    v-model="tab"
                    hide-delimiter-background
                    delimiter-icon="mdi-minus"
                  >
                    <template v-for="(img, i) in assingItem.imagenes">
                      <v-carousel-item :key="`img-`+i">
                        <!-- Verifica si es una miniatura -->
                        <v-img
                          :src="nombreImagen(img)"
                          max-height="500px"
                          max-width="100%"
                          contain
                        ></v-img>
                      </v-carousel-item>
                    </template>
                  </v-carousel>
                </v-col>
                <v-col cols="8">
                  <v-row>
                    <v-col cols="4">
                      <v-text-field
                        v-model.lazy="nombreSearch"
                        label="Nombre"
                        clearable
                        dense
                        hide-details
                        outlined
                      ></v-text-field>
                    </v-col>
                    
                    <v-col cols="4">
                      <v-text-field
                        v-model.lazy="apellidoPaternoSearch"
                        label="Apellido Paterno"
                        clearable
                        dense
                        hide-details
                        outlined
                      ></v-text-field>
                    </v-col>

                    <v-col cols="4">
                      <v-text-field
                        v-model.lazy="apellidoMaternoSearch"
                        label="Apellido Materno"
                        clearable
                        dense
                        hide-details
                        outlined
                      ></v-text-field>
                    </v-col>

                    <v-col cols="6">
                      <v-text-field
                        v-model.lazy="folioSearch"
                        label="Folio"
                        clearable
                        dense
                        hide-details
                        outlined
                      ></v-text-field>
                    </v-col>
                    <v-col cols="6">
                      <v-autocomplete
                        v-model="servicioSearch"
                        label="Servicio"
                        clearable
                        :items="servicios"
                        item-value="id_servicio"
                        item-text="nombre"
                        dense
                        hide-details
                        outlined
                      >
                      </v-autocomplete>
                    </v-col>
                    <v-col cols="12">
                      Rango de Fechas: 
                      <date-picker v-model="rangoSearch" range valueType="format" format="DD-MM-YYYY" @change="getItems"></date-picker>
                    </v-col>
                  </v-row>
                  <v-row style="max-width: 1800px !important;">
                    <v-col cols="12">
                      <v-data-table
                        :items="itemsSearch"
                        :headers="headersSearch"
                        :loading="loading"
                      >
                        <template v-slot:[`item.genero`]="{ item }">
                          {{item.genero ? "M" : "F"}}
                        </template>
                        <template v-slot:[`item.curp`]="{ item }">
                          {{item.curp == null ? "N/A" : item.curp}}
                        </template>
                        <template v-slot:[`item.seguro_popular`]="{ item }">
                          {{item.seguro_popular ? "Sí" : "No"}}
                        </template>
                        <template v-slot:[`item.num_poliza`]="{ item }">
                          {{item.num_poliza == null ? "N/A" : item.num_poliza}}
                        </template>
                        <template v-slot:[`item.telefono`]="{ item }">
                          {{item.telefono == null ? "N/A" : item.telefono}}
                        </template>
                        <template v-slot:[`item.actions`]="{ item }">
                          <v-icon
                            small
                            class="mr-2"
                            @click="openConfigDialog(item)"
                          >
                            mdi-check-bold
                          </v-icon>
                        </template>
                      </v-data-table>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-dialog>

        <v-data-table
          :loading="loading"
          :items="items"
          :headers="headers"
        >
          <template v-slot:[`item.nombre_completo`]="{ item }">
            {{item.nombre_paciente}} {{item.apellido_paterno_paciente}} {{item.apellido_materno_paciente}}
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-icon class="mr-2" @click="openDialogAssing(item)">
              mdi-account-check
            </v-icon>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import axios from 'axios'
import { mapState } from 'vuex'
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';
import _ from 'lodash';

export default {
  components: {
    DatePicker
  },
  computed: {
    ...mapState(["token", "storage_url"])
  },
  data: () => ({
    tab: null,
    loading: false,
    items: [],
    headers: [
      {
        text: "Folio",
        value: "folio",
        align: "center",
        width: "18%",
        sortable: false,
      },
      {
        text: "Nombre Completo",
        value: "nombre_completo",
        align: "center",
        width: "18%",
        sortable: false,
      },
      {
        text: "Sexo",
        value: "genero",
        align: "center",
        width: "18%",
        sortable: false,
      },
      {
        text: "Fecha Nacimiento",
        value: "fecha_nacimiento",
        align: "center",
        width: "18%",
        sortable: false,
      },
      {
        text: "Fecha Realización Estudio",
        value: "fecha_realizacion",
        align: "center",
        width: "18%",
        sortable: false,
      },
      {
        text: "Acciones",
        value: "actions",
        align: "center",
        width: "10%",
        sortable: false,
      },
    ],
    dialogAssing: false,
    assingItem: {
      nombre_paciente: "",
      apellido_paterno_paciente: "",
      apellido_materno_paciente: "",
      fecha_nacimiento: "",
      folio: "",
      fecha_realizacion: "",
      genero: "",
      imagenes: []
    },
    defaultAssingItem: {
      nombre_paciente: "",
      apellido_paterno_paciente: "",
      apellido_materno_paciente: "",
      fecha_nacimiento: "",
      folio: "",
      fecha_realizacion: "",
      genero: "",
      imagenes: []
    },
    savingAssing: false,

    nombreSearch: null,
    apellidoPaternoSearch: null,
    apellidoMaternoSearch: null,
    folioSearch: null,
    servicioSearch: null,
    rangoSearch: null,
    headersSearch:[
      {
        text: "Folio Paciente",
        value: "folio",
        align: "center",
        width: "9%",
        sortable: false,
      },
      {
        text: "Folio Servicio",
        value: "folio_servicio",
        align: "center",
        width: "9%",
        sortable: false,
      },
      {
        text: "Servicio",
        value: "servicio",
        align: "center",
        width: "9%",
        sortable: false,
      },
      {
        text: "Nombre",
        value: "nombre",
        align: "center",
        width: "9%",
        sortable: false,
      },
      {
        text: "Apellido Paterno",
        value: "apellido_paterno",
        align: "center",
        width: "9%",
        sortable: false,
      },
      {
        text: "Apellido Materno",
        value: "apellido_materno",
        align: "center",
        width: "9%",
        sortable: false,
      },
      {
        text: "Fecha de Nacimiento",
        value: "fecha_nacimiento",
        align: "center",
        width: "9%",
        sortable: false,
      },
      {
        text: "Edad",
        value: "edad",
        align: "center",
        width: "9%",
        sortable: false,
      },
      {
        text: "Sexo",
        value: "genero",
        align: "center",
        width: "9%",
        sortable: false,
      },
      {
        text: "Fecha Realización",
        value: "fecha_realizacion",
        align: "center",
        width: "9%",
        sortable: false,
      },
      {
        text: "Acciones",
        value: "actions",
        align: "center",
        width: "10%",
        sortable: false,
      }
    ],
    itemsSearch: [],
    servicios: [],
    loadingServicios: false,
    confirmItem: {
      id_paciente: null,
      id_paciente_servicio: null,
      folio: "",
      folio_servicio: "",
      nombre: "",
      apellido_paterno: "",
      apellido_materno: "",
      fecha_nacimiento: "",
      edad: "",
      genero: false,
      servicio: "",
      fecha_realizacion: null
    },
    defaultConfirmItem: {
      id_paciente: null,
      id_paciente_servicio: null,
      folio: "",
      folio_servicio: "",
      nombre: "",
      apellido_paterno: "",
      apellido_materno: "",
      fecha_nacimiento: "",
      edad: "",
      genero: false,
      servicio: "",
      fecha_realizacion: null
    },
    confirmDialog: false,
  }),
  mounted(){
    this.getItems();
    this.getServicios();
  },
  methods: {
    getItems(){
      this.loading = true;
      axios
      .get('/ConsultasMastografias/ImagenesSinAsignar')
      .then(response => {
        this.items = response.data
      })
      .catch(error => {
        console.log(error)
      })
      .finally(() => {
        this.loading = false;
      })
    },
    openDialogAssing(item){
      this.dialogAssing = true;
      this.assingItem = item;
      setTimeout(() => {
        this.getSearch();
    }, 500);
    },
    closeDialogAssing(){
      this.assingItem = Object.assign({}, this.defaultAssingItem);
      this.dialogAssing = false;
      this.nombreSearch = null;
      this.apellidoPaternoSearch = null;
      this.apellidoMaternoSearch =null;
      this.folioSearch = null;
      this.servicioSearch = null;
      this.rangoSearch = null;
      this.itemsSearch = [];
    },
    saveAssing(){
      const data = {
        folio: this.assingItem.folio,
        id_paciente_servicio: this.confirmItem.id_paciente_servicio
      };

      this.savingAssing = true;
      axios
        .post("/ConsultasMastografias/AsignarImagenesPacienteServicio", data)
        .then(() => {
          this.closeConfigDialog();
          this.closeDialogAssing();
          this.getItems(); 
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.savingAssing = false;
        });
    },
    nombreImagen(filename){
      return `${this.storage_url}/Dicom/GetThumnail/${filename}?jwt=${this.token}`;
    },
    debouncedSearchInput: _.debounce(function() {
      this.getSearch();
    }, 1000),
    getSearch() {
      const data = {
        nombre: this.nombreSearch,
        apellido_paterno: this.apellidoPaternoSearch,
        apellido_materno: this.apellidoMaternoSearch,
        folio: this.folioSearch,
        desde: this.rangoSearch?.[0] ?? null,
        hasta: this.rangoSearch?.[1] ?? null,
        id_servicio: this.servicioSearch,        
        dicom_nombre: this.assingItem.nombre_paciente,
        dicom_apellido_paterno: this.assingItem.apellido_paterno_paciente,
        dicom_apellido_materno: this.assingItem.apellido_materno,
        dicom_folio: this.assingItem.folio,
      };

      this.loading = true;
      axios
      .post("/ConsultasMastografias/ListarPacientes", data)
      .then(response => {
        this.itemsSearch = response.data;
      })
      .catch(error => {
        console.log(error);
      })
      .finally(() => {
        this.loading = false;
      });
    },
    getServicios(){
      this.loadingServicios = true;
      axios
      .get('/ConsultasMastografias/ListarServicios')
      .then(response => {
        this.servicios = response.data;
      })
      .catch(error => {
        console.log(error);
      })
      .finally(() => {
        this.loadingServicios = false;
      })
    },
    openConfigDialog(item){
      this.confirmDialog = true;
      this.confirmItem = Object.assign({}, item);
    },
    closeConfigDialog(){
      this.confirmDialog = false;
      this.confirmItem = Object.assign({}, this.defaultConfirmItem);
    }
  },
  watch: {
    nombreSearch: function() {
      this.debouncedSearchInput();
    },
    apellidoPaternoSearch: function() {
      this.debouncedSearchInput();
    },
    apellidoMaternoSearch: function() {
      this.debouncedSearchInput();
    },
    folioSearch: function() {
      this.debouncedSearchInput();
    },
    rangoSearch: function() {
      this.debouncedSearchInput();
    },
    servicioSearch: function() {
      this.debouncedSearchInput();
    },
  },
}
</script>